export default "__VITE_ASSET__VR6i7XSr__"